import { PageEvent } from './page-lifecycle/PageEvent';

const DEBUG_VERBOSE = false;
const CLASS_NAME = `InPageLinks`;

class InPageLinks {
	private element = document.querySelector('.in-page-links') as HTMLElement;
	private listEl = document.querySelector('.in-page-links .in-page-links__list') as HTMLElement;

	constructor() {
		DEBUG_VERBOSE && console.log(CLASS_NAME);
	}

	init() {
		DEBUG_VERBOSE && logger.log(CLASS_NAME, this.element, this.listEl);

		const button = this.element.querySelector('.in-page-links__top') as HTMLButtonElement;

		if (button) {
			button.onclick = () => {
				button.blur();
				requestAnimationFrame(() => {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				});
			};
		}

		this.processLinks(document);

		this.addPageEventListeners();
	}

	// ////////////////////////////////////////////////////////////////////

	private addPageEventListeners(): void {
		document.addEventListener(PageEvent.enter, (event: any) => {
			const parser = new DOMParser();

			const dom = parser.parseFromString(event.detail?.next?.html, 'text/html');

			if (dom.body && dom.body.innerHTML.includes('undefined')) return;

			// -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> ->

			this.processLinks(dom);
		});
	}

	// ////////////////////////////////////////////////////////////////////

	public setTabIndexOnLinks(state: boolean) {
		const links = Array.from(this.element.querySelectorAll('a, button')) as HTMLElement[];

		links.forEach((link) => {
			link.tabIndex = state ? 0 : -1;
		});
	}

	// ////////////////////////////////////////////////////////////////////

	private processLinks(target: Document) {
		// Grab all elements that have both an `id` and `ipl` attribute
		const links = Array.from(target.querySelectorAll('[id][ipl]')) as HTMLElement[];

		DEBUG_VERBOSE && logger.log(CLASS_NAME, this.processLinks.name, { links });

		// Remove any existing elements
		this.listEl.innerHTML = '';

		links.forEach((link) => {
			const { id } = link;
			const ipl = link.getAttribute('ipl');

			if (id && ipl) {
				const anchorEl = document.createElement('a');
				anchorEl.href = `#${id}`;
				anchorEl.textContent = ipl;
				anchorEl.tabIndex = -1; // Have links immune from tabbing until menu is activated
				anchorEl.onclick = (event: MouseEvent) => {
					// Handling click manually for two reasons
					// 1: After a barba transition traditional anchor linking appeared not to work
					// 2: An offet was required so the navbar dosn't obscure the linked content
					event.stopImmediatePropagation();
					event.preventDefault();

					const scrollToTargetEl = document.getElementById(id) as HTMLElement;

					if (!scrollToTargetEl) return;

					// -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> -> ->

					// Take into account the height of the navbar
					const scrollToTop = scrollToTargetEl.offsetTop - this.element.offsetHeight;

					window.scrollTo({ top: scrollToTop, behavior: 'smooth' });
				};

				const listItemEl = document.createElement('li');

				listItemEl.append(anchorEl);

				this.listEl.append(listItemEl);
			}
		});
	}
}

export default new InPageLinks();
